import { render } from "./PointExpiration.vue?vue&type=template&id=793801bb&scoped=true"
import script from "./PointExpiration.vue?vue&type=script&lang=js"
export * from "./PointExpiration.vue?vue&type=script&lang=js"

import "./PointExpiration.vue?vue&type=style&index=0&id=793801bb&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793801bb"]])

export default __exports__